module.exports = __webpack_public_path__ + "img/2026-10-11c_2.3b22da59.jpg";